import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello, My name is <span className="purple">Dimkpa Daniel </span>
            from <span className="purple"> Nigeria.</span>
            <br />I am a MERN Stack developer and a Data Analyst.
            <br />I have worked on projects like e-voting websites, business website, portfolio website, and CRUD web applications. 
            <br /> I'm available for projects and collaborations.
             <br />
             <br /> Some of my hobbies apart from coding are!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Console Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Football
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
            <li className="about-activity">
              <ImPointRight /> Studying
            </li>
          </ul>

          {/* <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p> */}
          {/* <footer className="blockquote-footer">Soumyajit</footer> */}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
